import {optionalMaterialInput} from "#material/nodes/base/connection/validation/parameters"
import type {MaterialNodeDefinition} from "#material/nodes/base/material/types/definition"
import {ExchangeNodeName} from "#material/exchange/node-name"
import {materialUiSchema} from "#material/nodes/base/material/validation/ui"
import type {MaterialNodeSockets} from "#material/types/material-node-sockets"
import {color} from "@cm/graph-v3"
import {z} from "zod/v4-mini"
import {materialClosureOutput} from "#material/nodes/base/material/validation/io"

export interface BsdfTransparentSockets extends MaterialNodeSockets {
    inputs: {
        color: "color" // found in inputs: color; found in settings: color; inferred from data: float3
    }
    settings: {
        color: "color" // found in inputs: color; found in settings: color; inferred from data: float3
    }
    outputs: {
        bsdf: "closure"
    }
}

export const bsdfTransparentDefinition = {
    exchangeFormat: {
        nodeName: ExchangeNodeName.ShaderNodeBsdfTransparent,
    },
    nodeClass: "BsdfTransparent",
    ui: {
        label: "Transparent BSDF",
        color: "#2d8a5d",
        items: [
            {name: "bsdf", label: "BSDF", valueType: "closure", output: true},
            {name: "color", label: "Color", valueType: "color", input: true, setting: true, defaultValue: {r: 1.0, g: 1.0, b: 1.0}},
        ],
        support: {
            cycles: true,
            three: true,
        },
    },
    validation: {
        returns: z.strictObject({bsdf: materialClosureOutput}),
        parameters: z.strictObject({
            inputs: z.strictObject({color: optionalMaterialInput}),
            settings: z.strictObject({
                color: z.optional(color),
            }),
            ui: materialUiSchema,
        }),
    },
} satisfies MaterialNodeDefinition<BsdfTransparentSockets>
